const PROTECTION_VARIANT_ID = 53536171032855;
const PROTECTION_RATE = 0.02;

let protectionBusy = false;

function formatINR(cents) {
  return 'Rs. ' + (cents / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

async function addProtection(quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: PROTECTION_VARIANT_ID,
      quantity,
      properties: {
        _shipping_protection: 'true'
      }
    })
  });
}

async function changeProtection(line, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      line,
      quantity
    })
  });
}

async function updateShippingProtection(enabled) {
  if (protectionBusy) return;
  protectionBusy = true;

  const cart = await getCart();

  const protectionIndex = cart.items.findIndex(
    item => Number(item.variant_id) === Number(PROTECTION_VARIANT_ID)
  );

  const subtotalWithoutProtection = cart.items
    .filter(item => Number(item.variant_id) !== Number(PROTECTION_VARIANT_ID))
    .reduce((sum, item) => sum + item.final_line_price, 0);

  const protectionQuantity = Math.ceil((subtotalWithoutProtection * PROTECTION_RATE) / 100);

  if (enabled) {
    if (protectionIndex === -1) {
      await addProtection(protectionQuantity);
    } else {
      await changeProtection(protectionIndex + 1, protectionQuantity);
    }
  } else {
    if (protectionIndex !== -1) {
      await changeProtection(protectionIndex + 1, 0);
    }
  }

  const updatedCart = await getCart();

  const totalEl = document.querySelector('[data-testid="cart-total-value"]');
  if (totalEl) {
    totalEl.textContent = formatINR(updatedCart.total_price) + ' INR';
  }

  protectionBusy = false;
}

document.addEventListener('change', function (e) {
  if (!e.target.matches('#shipping-protection-toggle')) return;
  updateShippingProtection(e.target.checked);
});